import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useEffect, useRef, useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import ZipCodeBarComponent from '@magalu/stereo-ui/organisms/ZipcodeBar';
import Grid from '@magalu/stereo-ui/atoms/Grid';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import { Icon } from '@magalu/stereo-ui-icons';
import { usePublisher } from '@magalu/mixer-publisher';
import { useLocation } from '@magalu/mixer-graphql';
import { isZipcodeInvalid, setLocationCookies } from '@magalu/mixer-utils';
import { ClosePopper, Container, Content, Popper, Title, ZipCodeBtn } from './ZipCodeBar.styles';
function ClosePopupBtn(_ref) {
  var onClick = _ref.onClick;
  return React.createElement(ClosePopper, {
    "data-testid": "close-btn",
    onClick: onClick
  }, React.createElement(Icon, {
    name: "Close",
    width: 24,
    height: 24,
    color: "white",
    cursor: "pointer",
    "data-testid": "Close"
  }));
}
process.env.NODE_ENV !== "production" ? ClosePopupBtn.propTypes = {
  onClick: func.isRequired
} : void 0;
var getZipcode = function getZipcode(shouldUpdateZipcode, locationZipCode, accountZipCode) {
  return shouldUpdateZipcode ? locationZipCode : accountZipCode;
};
function ZipCodeBar(_ref2) {
  var structure = _ref2.structure,
    staticProps = _ref2["static"],
    config = _ref2.config;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var parentRef = useRef(null);
  var _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    _structure$cookies2$l = _structure$cookies2.location,
    initialLocation = _structure$cookies2$l === void 0 ? {} : _structure$cookies2$l,
    rejectZipcodePopup = _structure$cookies2.rejectZipcodePopup,
    accountData = _structure$cookies2.accountData;
  var zipCodeBar = staticProps.zipCodeBar,
    _staticProps$popper = staticProps.popper,
    popper = _staticProps$popper === void 0 ? {
      enabled: false
    } : _staticProps$popper;
  var popperEnabled = popper.enabled,
    _popper$info = popper.info,
    _popper$info2 = _popper$info === void 0 ? {} : _popper$info,
    popperTitle = _popper$info2.title,
    popperContent = _popper$info2.content,
    popperBtnLabel = _popper$info2.buttonLabel,
    _popper$success = popper.success,
    _popper$success2 = _popper$success === void 0 ? {} : _popper$success,
    popperSuccessTitle = _popper$success2.title,
    popperSuccessContent = _popper$success2.content;
  var zipCodeBarText = zipCodeBar.zipCodeBarText;
  var _useState = useState(initialLocation),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useLocation = useLocation(),
    locationData = _useLocation.location,
    error = _useLocation.error,
    getData = _useLocation.getData;
  var shouldUpdateZipcode = isZipcodeInvalid(location);
  useEffect(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!((accountData == null ? void 0 : accountData.zip_code) && !initialLocation.zipCode || shouldUpdateZipcode)) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return getData({
            zipCode: getZipcode(shouldUpdateZipcode, location.zipCode, accountData.zip_code)
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  useEffect(_asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var zipCode, updatedLocation;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!error && locationData.location && (!location.zipCode || shouldUpdateZipcode)) {
            zipCode = getZipcode(shouldUpdateZipcode, location.zipCode, accountData.zip_code);
            updatedLocation = {
              zipCode: zipCode,
              zipCodeCity: locationData.location.city,
              zipCodeState: locationData.location.state
            };
            setLocationCookies(locationData.location, zipCode, structure, config);
            setLocation(updatedLocation);
            publish('zipcode:auto', updatedLocation);
          }
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [error, JSON.stringify(locationData.location)]);
  useEffect(function () {
    setLocation(initialLocation);
  }, [JSON.stringify(initialLocation)]);
  var _useState3 = useState(!initialLocation.zipCode && !rejectZipcodePopup ? 'info' : null),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopper = _useState4[0],
    setShowPopper = _useState4[1];
  var handleBarClick = function handleBarClick() {
    setShowPopper(null);
    publish('zipcodebar:click');
    publish('zipcodeinput:toggle');
  };
  var handlePopperBtn = function handlePopperBtn() {
    setShowPopper(null);
    publish('zipcodebar:popup:click');
    publish('zipcodeinput:toggle');
  };
  var handleClosePopper = function handleClosePopper() {
    publish('addtorejectzipcode:success');
    publish('zipcodebar:popup:close');
    setShowPopper(null);
  };
  var handleZipcodeSuccess = function handleZipcodeSuccess() {
    publish('zipcodebar:popup:success');
    setShowPopper('success');
  };
  useEffect(function () {
    subscribe('zipcodebar:response:success', handleZipcodeSuccess);
    return function () {
      unsubscribe('zipcodebar:response:success', handleZipcodeSuccess);
    };
  });
  useEffect(function () {
    if (showPopper) {
      publish('zipcodebar:popup:view');
    }
  }, [showPopper]);
  var renderInfoPopper = function renderInfoPopper() {
    return React.createElement(Grid, {
      mr: 1,
      ml: 1,
      mb: 2,
      pl: 1,
      "data-testid": "popper-info-container"
    }, React.createElement(ClosePopupBtn, {
      onClick: handleClosePopper
    }), React.createElement(Title, null, popperTitle), React.createElement(Content, null, popperContent), React.createElement(ZipCodeBtn, {
      "data-testid": "popper-btn",
      onClick: handlePopperBtn
    }, popperBtnLabel));
  };
  var renderSuccessPopper = function renderSuccessPopper() {
    return React.createElement(Flex, {
      gap: 2,
      p: 2,
      alignItems: "center",
      "data-testid": "popper-success-container"
    }, React.createElement(Icon, {
      name: "DoneCircle",
      width: 32,
      height: 32,
      color: "white",
      "data-testid": "DoneCircle"
    }), React.createElement(Box, null, React.createElement(Title, null, popperSuccessTitle), React.createElement(Content, null, popperSuccessContent)), React.createElement(ClosePopupBtn, {
      onClick: function onClick() {
        return setShowPopper(null);
      }
    }));
  };
  return React.createElement(Container, {
    ref: parentRef,
    "data-testid": "zipcode-bar"
  }, React.createElement(ZipCodeBarComponent, {
    text: zipCodeBarText.text,
    defaultText: zipCodeBarText.defaultText,
    zipcode: location.zipCode,
    city: location.zipCodeCity,
    state: location.zipCodeState,
    onClick: handleBarClick
  }), popperEnabled && React.createElement(Popper, {
    visible: !!showPopper,
    parentRef: parentRef
  }, showPopper === 'success' ? renderSuccessPopper() : renderInfoPopper()));
}
ZipCodeBar.ssr = false;
ZipCodeBar.defaultProps = {
  config: {}
};
process.env.NODE_ENV !== "production" ? ZipCodeBar.propTypes = {
  config: shape({}),
  "static": shape({
    popper: shape({
      enabled: bool,
      info: shape({
        buttonLabel: string,
        content: string,
        title: string
      }),
      success: shape({
        content: string,
        title: string
      })
    }),
    zipCodeBar: shape({
      defaultText: string,
      text: string
    })
  }).isRequired,
  structure: shape({
    cookies: shape({
      location: shape({
        zipCode: string,
        zipCodeCity: string,
        zipCodeState: string
      })
    })
  }).isRequired
} : void 0;
export default ZipCodeBar;